package org.ksdfv.thelema.test.fs

import org.ksdfv.thelema.fs.FS
import org.ksdfv.thelema.net.NET
import org.ksdfv.thelema.test.Test

class FSTest: Test {
    override val name: String
        get() = "Files"

    override fun testMain() {
        val internal = FS.internal("test-file.txt")
        internal.readBytes { status, bytes ->
            if (status == NET.OK) {
                if (!check("internal readBytes",
                        bytes[0].toInt() == 113,
                        bytes[1].toInt() == 119,
                        bytes[2].toInt() == 101,
                        bytes[3].toInt() == 114,
                        bytes[4].toInt() == 116,
                        bytes[5].toInt() == 121
                    )) {
                    println("Expected: 113 119 101 114 116 121")
                    print("Actual: ")
                    bytes.forEach { print(it.toInt()); print(" ") }
                    println()
                }
            } else {
                println("internal readBytes: FAILED")
                println("status: $status")
            }
        }
        internal.readText { status, text ->
            if (status == NET.OK) {
                if (!check("internal readText", text == "qwerty")) {
                    println("Expected: qwerty")
                    println("Actual: $text")
                }
            } else {
                println("internal readText: FAILED")
                println("status: $status")
            }
        }

        val local = FS.local("test-file.txt")
        local.readBytes { status, bytes ->
            if (status == NET.OK) {
                if (!check("local readBytes",
                        bytes[0].toInt() == 113,
                        bytes[1].toInt() == 119,
                        bytes[2].toInt() == 101,
                        bytes[3].toInt() == 114,
                        bytes[4].toInt() == 116,
                        bytes[5].toInt() == 121
                    )) {
                    println("Expected: 113 119 101 114 116 121")
                    print("Actual: ")
                    bytes.forEach { print(it.toInt()); print(" ") }
                    println()
                }
            } else {
                println("local readBytes: FAILED")
                println("status: $status")
            }
        }
        local.readText { status, text ->
            if (status == NET.OK) {
                if (!check("local readText", text == "qwerty")) {
                    println("Expected: qwerty")
                    println("Actual: $text")
                }
            } else {
                println("local readText: FAILED")
                println("status: $status")
            }
        }
    }
}